export default "__VITE_ASSET__DpdU6hNo__"